import React from 'react';
import { Box, Image, Text, VStack, Heading, SimpleGrid } from '@chakra-ui/react';
import { simpleRecipeList, SimpleRecipe } from '../../libs/SimpleRecipeData.ts';

const RecipeComponent = () => {
  return (
    <VStack spacing={8}>
      <Heading as="h1" size="xl" textAlign="center" marginTop="5">
        Color Recipe Lab
      </Heading>
      <SimpleGrid columns={{ base: 2, md: 4, lg: 4 }} spacing={5} m={5}>
        {simpleRecipeList.map((recipe: SimpleRecipe) => (
          <Box key={recipe.id} borderWidth="1px" borderRadius="lg" overflow="hidden">
            <Image src={recipe.image} alt={`Image of ${recipe.style}`} />
            <Box p="6">
              <Text fontWeight="bold" letterSpacing="wide" fontSize="xl" lineHeight="tight">
                {recipe.style}
              </Text>
              <Text fontWeight="bold" letterSpacing="wide" fontSize="xl" lineHeight="tight">
                {recipe.salon}
              </Text>
              <Text mt="2" fontWeight="semibold" as="h4" lineHeight="tight">
                {recipe.stylist}
              </Text>
              <Text>{recipe.color}</Text>
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </VStack>
  );
};

export default RecipeComponent;
